import type { CreditEstimate, CreditEstimateServiceKind } from '@/api/creditsApi'

export type EstimateStationKind = CreditEstimateServiceKind

export function defaultEstimateQuantity(kind: EstimateStationKind): number {
  switch (kind) {
    case 'image':
    case 'audio':
    case 'video':
      return 1
  }
}

export function creditEstimateLabel(credits: number | null | undefined, language?: string): string {
  const value = formatCreditNumber(credits, language)
  return language?.toLowerCase().startsWith('zh') ? `本次约 ${value} Credits` : `About ${value} Credits this run`
}

function formatCreditNumber(credits: number | null | undefined, language?: string): string {
  if (typeof credits !== 'number' || !Number.isFinite(credits)) return '—'
  const locale = language?.toLowerCase().startsWith('zh') ? 'zh-CN' : 'en-US'
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(Math.round(credits))
}

export function isCreditEstimateInsufficient(
  estimate: Pick<CreditEstimate, 'enabled' | 'available_credits' | 'estimated_credits'> | null | undefined,
): boolean {
  return Boolean(estimate?.enabled && estimate.available_credits < estimate.estimated_credits)
}

export function requiresVideoCreditConfirmation(
  kind: string,
  estimate: Pick<CreditEstimate, 'estimated_credits'> | null | undefined,
): boolean {
  return kind === 'video' && Boolean(estimate && estimate.estimated_credits > 0)
}
